export default function SpeckleIntroduction(p: {
  isExpanded: boolean;
  onExpand(): void;
}) {
  return (
    <>
      <h3 className="font-bold">
        Bring your Speckle models into Keyframe with ease.
      </h3>
      <p className="mb-4 mt-6">
        The Keyframe & Speckle integration is a great way to streamline your
        projects workflow.
        {!p.isExpanded && (
          <button
            type="button"
            className="mb-6 ml-3 inline rounded p-0.5 text-xs font-medium"
            onClick={p.onExpand}
          >
            Read more
          </button>
        )}
      </p>
      {p.isExpanded && (
        <>
          <ul className="list-inside list-disc space-y-1.5">
            <li>
              Simply select the Speckle project, model, and version that you
              want to import, and Keyframe will take care of the rest.
            </li>
            <li>
              Once the import is complete, your model will be available in the
              Keyframe models list, ready for you to start working on.
            </li>
          </ul>
          <p className="mb-4 mt-6">
            If you&apos;re unfamiliar with&nbsp;Speckle
          </p>
          <ul className="mb-12 list-inside list-disc space-y-1.5">
            <li>
              Speckle is a cloud-based platform for storing and sharing 3D data.
            </li>
            <li>
              It makes it easy to collaborate with others on projects and to
              bring your 3D models into other software applications.
            </li>
            <li>Speckle data can now be brought in and viewed in Keyframe.</li>
          </ul>
        </>
      )}
    </>
  );
}
